import { useCallback, useEffect } from 'react';

type Listener = () => boolean | Promise<boolean>;
const beforeCloseListeners: Listener[] = [];

function useModalBlocker(when: boolean, blocker: Listener) {
    useEffect(() => {
        if (when) {
            beforeCloseListeners.push(blocker);
        }

        return () => {
            const index = beforeCloseListeners.indexOf(blocker);
            beforeCloseListeners.splice(index, 1);
        };
    }, [blocker, when]);
}

export const doModalListenersBlockClose = async () => {
    if (beforeCloseListeners.length) {
        const promises = beforeCloseListeners.map((listener) => listener());
        const values = await Promise.all(promises);

        return values.some((value) => !value);
    }

    return false;
};

export default function useModalPrompt(message: string, when = true) {
    useModalBlocker(
        when,
        useCallback(() => confirm(message), [message]),
    );
}
